import moment from "moment";

const MAX_DAYS_LIMIT = 31;
const MAX_MONTHS_LIMIT = 6;

export default class GranularityHelper {
  private granularity: "day" | "sweek" | "month";
  private fromDate: string;
  private toDate: string;

  private validGranularityItems = new Set();

  constructor(
    granularity: "day" | "sweek" | "month",
    fromDate: string,
    toDate: string
  ) {
    this.granularity = granularity;
    this.fromDate = fromDate;
    this.toDate = toDate;
  }

  get value() {
    return this.granularity;
  }

  set value(value: "day" | "sweek" | "month") {
    this.granularity = value;
    this.updateGranularity();
  }

  get validItems() {
    return [...this.validGranularityItems];
  }

  get daysCount(): number {
    const start = moment(this.fromDate);
    const end = moment(this.toDate);

    return end.diff(start, "days") + 1;
  }

  get monthsCount(): number {
    const start = moment(this.fromDate);
    const end = moment(this.toDate);

    return end.diff(start, "months") + 1;
  }

  updateRange(from: string, to: string) {
    this.fromDate = from;
    this.toDate = to;
    this.updateGranularity();
  }

  protected updateGranularity() {
    this.validGranularityItems = new Set(["day", "sweek", "month"]);
    if (this.monthsCount > MAX_MONTHS_LIMIT) {
      this.validGranularityItems.delete("day");
      this.validGranularityItems.delete("sweek");
      this.granularity = "month";
    } else if (this.daysCount > MAX_DAYS_LIMIT) {
      this.validGranularityItems.delete("day");

      if (this.granularity == "day") {
        this.granularity = "sweek";
      }
    }
  }
}
